import { Layout, Menu } from "antd"
import React from "react"
import { ISidebarItems } from "@/types/layout"
import { Link } from "react-router-dom"

const { Sider } = Layout

const AppSidebar = ({
  sidebarItems,
  selectedItem,
}: {
  sidebarItems: ISidebarItems
  selectedItem: string
}) => {
  return (
    <Sider
      width={200}
      style={{
        minHeight: "calc(100%)",
        backgroundColor: "white",
        paddingTop: 17,
      }}
    >
      <Menu mode="inline" defaultSelectedKeys={[selectedItem.replace("/", "")]}>
        {sidebarItems.map((item) => (
          <Menu.Item key={item.key}>
            <Link to={item.route}>{item.name}</Link>
          </Menu.Item>
        ))}
      </Menu>
    </Sider>
  )
}

export default AppSidebar
